/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Error_Auth_FailedInputs */

const vi_einvoice_error_auth_failed = /** @type {(inputs: Einvoice_Error_Auth_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không đăng nhập được MISA. Vào Cài đặt → Hóa đơn để kiểm tra kết nối tài khoản MISA của bạn.`)
};

/**

* @param {Einvoice_Error_Auth_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_error_auth_failed = /** @type {((inputs?: Einvoice_Error_Auth_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Error_Auth_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_error_auth_failed(inputs)
});